const API_URL = process.env.REACT_APP_API_URL || 'https://real.suraviantisuiciderod.com/api';

/**
 * Resolve an image path returned by the API. If the path is already absolute (http/https), return as-is.
 * If it starts with '/uploads' or doesn't look absolute, prefix with API origin (without trailing '/api').
 */
export const getImageUrl = (path) => {
  if (!path) return null;

  if (typeof path === 'object') {
    const candidate = path.url || path.path || path.preview || path.image || path.src;
    if (!candidate) return null;
    return getImageUrl(candidate);
  }

  try {
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
  } catch (e) {
    return null;
  }

  // If API_URL contains '/api', strip it to get origin
  const origin = API_URL.replace(/\/api\/?$/, '');
  if (path.startsWith('/')) return `${origin}${path}`;
  return `${origin}/${path}`;
};

export default getImageUrl;
